// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"ScrollShadow_scrollWrapper__6kBVO","shadow":"ScrollShadow_shadow__pVW++","ScrollHint":"ScrollShadow_ScrollHint__TaGqY"};